import { render } from "./AudioFeatureModalTemplate.vue?vue&type=template&id=0f1f1352"
import script from "./AudioFeatureModalTemplate.vue?vue&type=script&lang=js"
export * from "./AudioFeatureModalTemplate.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0f1f1352"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f1f1352', script)) {
    api.reload('0f1f1352', script)
  }
  
  module.hot.accept("./AudioFeatureModalTemplate.vue?vue&type=template&id=0f1f1352", () => {
    api.rerender('0f1f1352', render)
  })

}

script.__file = "resources/js/Pages/Station/Partials/Features/AudioGuide/AudioFeatureModalTemplate.vue"

export default script